import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { MediaAsset } from '../../views'
import { campaignDetailsLogoUploadAtom } from '../state'

export type UseCampaignDetailsLogoUploadArgs = {
	onLogoUpload: ((logo: File, callback: (asset: MediaAsset) => void, onFail?: () => void) => void) | undefined
}

/**
 * Hook to set the logo upload callback for campaign details.
 * This allows route-level hooks to provide logo upload functionality to the editor.
 */
export function useCampaignDetailsLogoUpload({ onLogoUpload }: UseCampaignDetailsLogoUploadArgs) {
	const setLogoUploadCallback = useSetAtom(campaignDetailsLogoUploadAtom)

	useEffect(() => {
		setLogoUploadCallback(() => onLogoUpload)
	}, [onLogoUpload, setLogoUploadCallback])
}
